import { IState } from '../../store';

export function getPassengerLiftCounts(state: IState) {
  const {
    offerData: {
      offer: { building },
    },
  } = state;

  return building && building.passengerLiftsCount;
}
